export const EXAMPLE_VIEWS = [
    {
        id: '7243',
        name: 'Overview',
        type: 'predefined',
    },
    {
        id: '5951',
        name: 'Split Overview',
        type: 'predefined',
    },
    {
        id: '2131',
        name: 'Lite Overview',
        type: 'predefined',
    },
    {
        id: '9401',
        name: 'My View 2',
        type: 'custom',
        createdBy: 'Guy Hawkins',
    },
    {
        id: '0413',
        name: 'My View 3',
        type: 'custom',
        createdBy: 'Darlene Robertson',
    },
    {
        id: '1300',
        name: 'My View 1',
        type: 'custom',
        pinned: true,
        createdBy: 'Leslie Alexander',
    },
];
export const EXAMPLE_VIEWS_WITH_CUSTOM_PERMISSIONS = [
    {
        id: '7243',
        name: 'Overview',
        type: 'predefined',
    },
    {
        id: '5951',
        name: 'Split Overview',
        type: 'predefined',
        permissions: {
            open: false,
        },
    },
    {
        id: '2131',
        name: 'Lite Overview',
        type: 'predefined',
    },
    {
        id: '9401',
        name: 'My View 2',
        type: 'custom',
        createdBy: 'Guy Hawkins',
        permissions: {
            edit: false,
            open: true,
            pin: false,
            remove: false,
        },
    },
    {
        id: '0413',
        name: 'My View 3',
        type: 'custom',
        createdBy: 'Darlene Robertson',
        permissions: {
            edit: true,
            open: true,
            pin: true,
            remove: false,
        },
    },
    {
        id: '1300',
        name: 'My View 1',
        type: 'custom',
        pinned: true,
        createdBy: 'Leslie Alexander',
        permissions: {
            edit: false,
            open: false,
            pin: false,
            remove: false,
        },
    },
];
export const EXAMPLE_ACTIVE_VIEW = EXAMPLE_VIEWS[0];
export const DEFAULT_VIEW_TYPE_PERMISSIONS = {
    common: {
        create: true,
    },
    custom: {
        edit: true,
        open: true,
        pin: true,
        remove: true,
    },
    predefined: {
        open: true,
    },
};
export const DEFAULT_MAX_NAME_LENGTH = 200;
//# sourceMappingURL=ViewsMenu.constants.js.map